import DataTable from "../../components/dataTables/DataTable";
import { useCollection, useRecipe, useRecipes } from "../../hooks";
import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import {
  Recipe,
  RecipeIngredientLists,
} from "../../data-parsing/recipes/Recipe";
import { buildColDefs } from "../../components/dataTables/buildColDefs";
import { useImperativeHandle, useRef, useState } from "react";
import {
  CreationForm,
  CreationFormInput,
  CreationFormTemplate,
} from "../../components/form/CreationForm";
import { AddRecipeFormTemplate } from "../../data-parsing/recipes/FormTemplate";
import { TabbedContent } from "../../components/tabs/TabbedContent";
import { AddIngredientFormTemplate } from "../../data-parsing/ingredients/FormTemplate";
import {
  Ingredient,
  SpecificIngredient,
} from "../../data-parsing/ingredients/Ingredient";
import { parseFormData } from "../../data-parsing/parseUtils";
import { Aliment } from "../../data-parsing/aliments/Aliment";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { IngredientForm } from "../../data-parsing/recipes/IngredientForm";

export function Recipes() {
  const [query, setQuery] = useState(0);
  let { recipes, createRecipe, testRecipe, testedRecipe } = useRecipes(query);
  let colDefs = buildColDefs(Recipe);
  const { putRecipe } = useRecipe();
  const callBackRef = useRef(); //ref to this Recipes object

  const [prepVar, setPrepVar] = useState("");

  const ingredientFormRef = useRef(); //ref for the ingredients

  const [generatedName, setGeneratedName] = useState("");
  const [generatedPreparation, setGeneratedPreparation] = useState("");

  const handleSaveRecipe = (event) => {
    event.preventDefault();
    if (testedRecipe !== undefined) {
      //We insert the recipe
      createRecipe(testedRecipe);
      //We reload the page
      //window.location.reload();
    } else {
      alert("Compruebe primero la receta antes de guardar");
    }
  };

  function checkRecipe(recipe) {
    console.log(recipe);
    const ingredientList = getIngredientList(recipe);

    let json = recipe;

    json = { ...getFormattedRecipe(json), ...ingredientList };
    json = fillPrepTexts(json);

    testRecipe(json)
      .then((response) => {
        setGeneratedName(response.name);
        setGeneratedPreparation(response.preparation);
      })
      .catch((error) => {
        console.error("Ocurrió un error:", error);
      });
  }

  //If there's 2 or more equal preparations on a group, they should
  //share the same T (T1,T2,T3,...). If not, prep_text should be FALSE
  function fillPrepTexts(json) {
    const groupNames = [
      "veg_ingredients",
      "carb_ingredients",
      "pro_ingredients",
      "fat_ingredients",
      "dairy_ingredients",
      "fruit_ingredients",
      "seasoning",
    ];

    const groupPrefixes = {
      veg_ingredients: "vege",
      carb_ingredients: "ch",
      pro_ingredients: "prot",
      fat_ingredients: "fats",
      dairy_ingredients: "dairy",
      fruit_ingredients: "frut",
      seasoning: "seasoning",
    };

    groupNames.forEach((groupName) => {
      let prepIndex = 1;
      let group = json[groupName];
      let groupPreparation = group["group_preparation"];
      let ingredients = group["ingredient_list"];
      ingredients.forEach((ingredient, index) => {
        //if an ingredient has the same preparation as the group
        if (ingredient.ingredient_preparation === groupPreparation) {
          if (group[groupPrefixes[groupName] + "_prep_text"] === undefined) {
            ingredient[groupPrefixes[groupName] + "_prep_text"] =
              "T" + prepIndex;
            group[groupPrefixes[groupName] + "_prep_text"] = "T" + prepIndex;
          } else {
            ingredient[groupPrefixes[groupName] + "_prep_text"] =
              group[groupPrefixes[groupName] + "_prep_text"];
          }
          prepIndex++;
        } else {
          //we check every ingredient
          for (let i = 0; i < ingredients.length; i++) {
            if (i !== index) {
              if (
                ingredient.ingredient_preparation ===
                ingredients[i].ingredient_preparation
              ) {
                if (
                  ingredient[groupPrefixes[groupName] + "_prep_text"] ===
                    undefined &&
                  ingredients[i][groupPrefixes[groupName] + "_prep_text"] ===
                    undefined
                ) {
                }

                var prepText =
                  ingredients[i][groupPrefixes[groupName] + "_prep_text"] ===
                  undefined
                    ? "T" + prepIndex
                    : ingredients[i][groupPrefixes[groupName] + "_prep_text"];
                ingredient[groupPrefixes[groupName] + "_prep_text"] = prepText;
                ingredients[i][groupPrefixes[groupName] + "_prep_text"] =
                  prepText;
                prepIndex++;
                break;
              }
            }

            //If no preparation is equal, prep_text is false
            if (
              ingredient[groupPrefixes[groupName] + "_prep_text"] === undefined
            ) {
              ingredient[groupPrefixes[groupName] + "_prep_text"] = "FALSE";
            }
          }
        }
      });
      //If no ingredient has the same preparation as the base one
      if (group[groupPrefixes[groupName] + "_prep_text"] === undefined) {
        group[groupPrefixes[groupName] + "_prep_text"] = "FALSE";
      }
    });
    console.log(json);
    return json;
  }

  //Gets the ingredient list from IngredientForm component, and formats it
  function getIngredientList(recipe) {
    var ingredientList;
    if (ingredientFormRef.current) {
      ingredientList = ingredientFormRef.current.getIngredientList();
    }

    var formattedIngredientList = {};

    //Variables from the ingredient group
    var weights = recipe["max_weight"];
    var visibleNames = recipe["visible_name"];
    var maxAmounts = recipe["max_amount"];
    var minAmounts = recipe["min_amount"];
    //var units = recipe["units"];  //Not on recipes anymore, now on aliments
    var groupPreparations = recipe["group_preparation"];

    var veg_ingredients = {
      max_weight: parseInt(weights[0]),
      visible_name: visibleNames[0],
      max_amount: parseFloat(maxAmounts[0]),
      //min_amount: parseFloat(minAmounts[0]),
      //units: units[0],
      group_preparation: groupPreparations[0].toString().replace(/\n/g, " "),
      ingredient_list:
        ingredientList["VEGE"][0]._id !== undefined
          ? ingredientList["VEGE"]
          : [],
    };
    var carb_ingredients = {
      max_weight: parseInt(weights[1]),
      visible_name: visibleNames[1],
      max_amount: parseFloat(maxAmounts[1]),
      min_amount: parseFloat(minAmounts[1]),
      //units: units[1],
      group_preparation: groupPreparations[1].replace(/\n/g, " "),
      ingredient_list:
        ingredientList["CARB"][0]._id !== undefined
          ? ingredientList["CARB"]
          : [],
    };
    var pro_ingredients = {
      max_weight: parseInt(weights[2]),
      visible_name: visibleNames[2],
      max_amount: parseFloat(maxAmounts[2]),
      min_amount: parseFloat(minAmounts[2]),
      //units: units[2],
      group_preparation: groupPreparations[2].replace(/\n/g, " "),
      ingredient_list:
        ingredientList["PROT"][0]._id !== undefined
          ? ingredientList["PROT"]
          : [],
    };
    var fat_ingredients = {
      max_weight: parseInt(weights[3]),
      visible_name: visibleNames[3],
      max_amount: parseFloat(maxAmounts[3]),
      min_amount: parseFloat(minAmounts[3]),
      //units: units[3],
      group_preparation: groupPreparations[3].replace(/\n/g, " "),
      ingredient_list:
        ingredientList["FATS"][0]._id !== undefined
          ? ingredientList["FATS"]
          : [],
    };
    var dairy_ingredients = {
      max_weight: parseInt(weights[4]),
      visible_name: visibleNames[4],
      max_amount: parseFloat(maxAmounts[4]),
      min_amount: parseFloat(minAmounts[4]),
      //units: units[4],
      group_preparation: groupPreparations[4].replace(/\n/g, " "),
      ingredient_list:
        ingredientList["DAIR"][0]._id !== undefined
          ? ingredientList["DAIR"]
          : [],
    };
    var fruit_ingredients = {
      max_weight: parseInt(weights[5]),
      visible_name: visibleNames[5],
      max_amount: parseFloat(maxAmounts[5]),
      min_amount: parseFloat(minAmounts[5]),
      //units: units[5],
      group_preparation: groupPreparations[5].replace(/\n/g, " "),
      ingredient_list:
        ingredientList["FRUT"][0]._id !== undefined
          ? ingredientList["FRUT"]
          : [],
    };
    var seasoning = {
      max_weight: parseInt(weights[6]),
      visible_name: visibleNames[6],
      //max_amount: parseFloat(maxAmounts[6]),
      //min_amount: parseFloat(minAmounts[6]),
      //units: units[6],
      group_preparation: groupPreparations[6].replace(/\n/g, " "),
      ingredient_list:
        ingredientList["SEAS"][0]._id !== undefined
          ? ingredientList["SEAS"]
          : [],
    };

    formattedIngredientList = {
      veg_ingredients,
      carb_ingredients,
      pro_ingredients,
      fat_ingredients,
      dairy_ingredients,
      fruit_ingredients,
      seasoning,
    };

    return formattedIngredientList;
  }

  function handleBlurInPrepVar(ev) {
    console.log(ev.target.value);
    setPrepVar(ev.target.value);
  }

  function getFormattedRecipe(recipe) {
    //backend only accepts arrays, and the forms only format the data as
    //an array when length > 1, so we have to convert the data to array
    //if there's only one value on a determined field, so "BREAK" -> ["BREAK"]

    recipe["suited_meal"] = Array.isArray(recipe["suited_meal"])
      ? recipe["suited_meal"]
      : [recipe["suited_meal"]];

    recipe["dish_type"] = Array.isArray(recipe["dish_type"])
      ? recipe["dish_type"]
      : [recipe["dish_type"]];

    recipe["week_day"] = Array.isArray(recipe["week_day"])
      ? recipe["week_day"]
      : [recipe["week_day"]];

    recipe["cook_type"] = Array.isArray(recipe["cook_type"])
      ? recipe["cook_type"]
      : [recipe["cook_type"]];

    recipe["cook_aux"] = Array.isArray(recipe["cook_aux"])
      ? recipe["cook_aux"]
      : [recipe["cook_aux"]];

    recipe["season"] = Array.isArray(recipe["season"])
      ? recipe["season"]
      : [recipe["season"]];

    recipe["rep_group_var"] = Array.isArray(recipe["nutrient_group"])
      ? recipe["nutrient_group"]
      : [recipe["nutrient_group"]];

    delete recipe["nutrient_group"];

    //delete not necessary info from ingredient groups
    delete recipe["max_weight"];
    delete recipe["visible_name"];
    delete recipe["max_amount"];
    delete recipe["min_amount"];
    delete recipe["units"];
    delete recipe["group_preparation"];

    return recipe;
  }

  return (
    <LeftSideMenu active="recipes">
      <div id="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className="card-box card-tabs m-t-20">
                <h4 className="header-title m-t-0 m-b-30 pull-right">
                  RECETAS
                </h4>

                <TabbedContent
                  tabHeaders={[
                    <button data-toggle="tab" aria-expanded="true">
                      <i className="fas fa-plus-circle"></i> NUEVA RECETA
                    </button>,
                    <button
                      data-toggle="tab"
                      aria-expanded="false"
                      onClick={() => setQuery(0)}
                    >
                      <i className="far fa-eye"></i> LISTAR RECETAS
                    </button>,
                  ]}
                >
                  <div className="fade in">
                    <div className="row">
                      <CreationForm
                        createFunction={
                          checkRecipe
                        } /*afterSubmit={afterSubmit}*/
                      >
                        <IngredientForm
                          ref={ingredientFormRef}
                          prepVar={prepVar}
                          generatedName={generatedName}
                          generatedPreparation={generatedPreparation}
                        />

                        <CreationFormTemplate
                          formTemplate={AddRecipeFormTemplate(
                            handleBlurInPrepVar
                          )}
                          dataTemplate={Recipe}
                        />

                        <div className="col-sm-12">
                          <button
                            className="btn btn-rounded btn-purple m-t-20"
                            style={{ marginLeft: "12px" }}
                          >
                            <i className="fa fa-check"></i> Comprobar Receta
                          </button>
                          <button
                            type="button"
                            className="btn btn-rounded btn-purple m-t-20"
                            style={{ marginLeft: "12px" }}
                            onClick={handleSaveRecipe}
                          >
                            <i className="fa fa-save"></i> Guardar Receta
                          </button>
                        </div>
                      </CreationForm>
                    </div>
                  </div>
                  <div className="fade in">
                    <DataTable
                      colDefs={colDefs}
                      data={recipes}
                      dataId={"Recipes"}
                      resizable={true}
                      allowHiddenColumns={true}
                      scrollX={true}
                      editElement={putRecipe}
                      className="table table-bordered panel-group"
                    />
                  </div>
                </TabbedContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}

/**
 ** ----  August 2024  ----
 ** Old Recipes and Ingredients components.
 ** IngredientForms is used instead now for almost all forms.
 ** There are some elements like IngredientTab that are being used aswell.
 */

export function Ingredients({ callBackRef }) {
  const ingredientTabs = [
    Recipe.veg_ingredients,
    Recipe.carb_ingredients,
    Recipe.pro_ingredients,
    Recipe.fat_ingredients,
    Recipe.dairy_ingredients,
    Recipe.fruit_ingredients,
  ];
  const ingredientGroups = [
    "VEGE",
    "CARB",
    "PROT",
    "FATS",
    "DAIR",
    "FRUT",
    "SEAS",
  ];
  const formObjectTemplate = getCopy(Ingredient);
  const [ingredientCount, setIngredientCount] = useState(initFormData());
  const currentIngredientGroup = useRef(ingredientGroups[0]);

  function getCopy(objectToCopy) {
    let copy = {};
    Object.keys(objectToCopy).forEach((key) => {
      copy[key] = undefined;
    });
    return copy;
  }

  function initFormData() {
    let formData = {};
    ingredientGroups.forEach((ingredientGroup) => {
      // Change this value to have any number of ingredients on the form by default
      formData[ingredientGroup] = Array(1).fill(formObjectTemplate);
    });
    return formData;
  }

  function afterSubmit(newElement, parsedData, ingredientGroup) {
    callBackRef.current?.updateValue(parsedData, ingredientGroup);
    // When there are no elements on the form, parsed data will contain
    // an empty object, meaning there is no need to add another one
    if (Object.keys(parsedData[0])?.length > 0) {
      parsedData.push(formObjectTemplate);
    }
    currentIngredientGroup.current = ingredientGroup;
    ingredientCount[ingredientGroup] = parsedData;
    setIngredientCount({ ...ingredientCount });
  }

  function handleChange(ev, ingredientGroup, index, ...other) {
    const parsedData = parseFormData(document.getElementById(ingredientGroup));

    if ({ ...other } && { ...other }.length >= 0 && { ...other }[0].name) {
      parsedData[index][{ ...other }[0].name] = ev.value;
    }

    //error in field when writing
    /*
        if ({...other} && {...other}[0].name) {
            parsedData[index][{...other}[0].name] = ev.value;
        }
        */

    currentIngredientGroup.current = ingredientGroup;
    ingredientCount[ingredientGroup] = parsedData;
    setIngredientCount({ ...ingredientCount });
    callBackRef.current?.updateValue(parsedData, ingredientGroup);
  }

  function removeIngredient(ev, ingredientGroup, index) {
    ev.preventDefault();
    ev.stopPropagation();
    const parsedData = parseFormData(document.getElementById(ingredientGroup));
    ingredientCount[ingredientGroup] = parsedData;
    ingredientCount[ingredientGroup].splice(index, 1);
    currentIngredientGroup.current = ingredientGroup;
    setIngredientCount({ ...ingredientCount });
    callBackRef.current?.updateValue(parsedData, ingredientGroup);
  }

  function handleTabChange() {
    ingredientCount[currentIngredientGroup.current] = parseFormData(
      document.getElementById(currentIngredientGroup.current)
    ).filter((obj) => {
      return Object.keys(obj).length > 0;
    });
    setIngredientCount({ ...ingredientCount });
  }

  return (
    <div className={"pl-10 pr-10"}>
      <TabbedContent
        removeContent={false}
        onTabChange={handleTabChange}
        tabHeaders={ingredientTabs.map((tab, index) => {
          return (
            <button data-toggle="tab" aria-expanded={index === 0}>
              {tab.visibleName}
            </button>
          );
        })}
      >
        {ingredientGroups.map((ingredientGroup) => {
          return (
            <CreationForm
              id={ingredientGroup}
              key={ingredientGroup}
              afterSubmit={(newElement, parsedData) =>
                afterSubmit(newElement, parsedData, ingredientGroup)
              }
            >
              <div key={ingredientGroup} className="fade in mt-20">
                {ingredientCount[ingredientGroup]?.map((ingredient, index) => {
                  return (
                    <div key={ingredient._id}>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <CreationFormInput
                          name={"_id"}
                          size={0.5}
                          onChange={(ev, ...other) =>
                            handleChange(ev, ingredientGroup, index, ...other)
                          }
                          defaultValue={ingredient._id}
                          inputData={SpecificIngredient(ingredientGroup)._id}
                        />

                        <span
                          className="btn btn-danger pull-right mr-10"
                          data-toggle="tooltip"
                          onClick={(ev) =>
                            removeIngredient(ev, ingredientGroup, index)
                          }
                        >
                          <i className="far fa-trash-alt" />
                        </span>
                      </span>

                      <CreationFormTemplate
                        defaultData={ingredient}
                        onChange={(ev, ...other) =>
                          handleChange(ev, ingredientGroup, index, ...other)
                        }
                        formTemplate={AddIngredientFormTemplate(
                          ingredientGroup
                        )}
                        dataTemplate={Ingredient}
                      />
                    </div>
                  );
                })}
              </div>

              <button
                className="btn btn-rounded btn-purple m-t-20"
                style={{ marginLeft: "12px" }}
              >
                <i className="fas fa-plus-circle"></i> Nuevo Ingrediente
              </button>
            </CreationForm>
          );
        })}
      </TabbedContent>
    </div>
  );
}

export function IngredientTab({ ingredientListName, afterSubmit }) {
  const ingredientGroup = RecipeIngredientLists[ingredientListName];

  function getCopy(objectToCopy) {
    let copy = {};
    Object.keys(objectToCopy).forEach((key) => {
      copy[key] = undefined;
    });
    return copy;
  }
  return (
    <div className={"pl-10 pr-10"}>
      <CreationForm
        id={ingredientGroup}
        key={ingredientGroup}
        afterSubmit={afterSubmit}
      >
        <div key={ingredientGroup} className="fade in mt-20">
          <>
            <span
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <CreationFormInput
                name={"_id"}
                size={0.5}
                inputData={SpecificIngredient(ingredientGroup)._id}
              />
            </span>

            <CreationFormTemplate
              formTemplate={AddIngredientFormTemplate(ingredientGroup)}
              dataTemplate={Ingredient}
            />
          </>
        </div>

        <button
          className="btn btn-rounded btn-purple m-t-20"
          style={{ marginLeft: "12px" }}
        >
          <i className="fas fa-plus-circle"></i> Nuevo Ingrediente
        </button>
      </CreationForm>
    </div>
  );
}

function RecipeName({ callBackRef }) {
  const alimentCollection = useCollection(Aliment);
  const [visibleIngredients, setVisibleIngredients] = useState({});
  const [ingredientList, setIngredientList] = useState([]);
  const grid = 4;

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid,
    margin: `0 ${grid}px 0 0`,
    // change background colour if dragging
    background: isDragging ? "#71b6f" : "hsl(0, 0%, 90%)",
    borderRadius: "4px",
    color: "hsl(0, 0%, 20%)",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "#71b6f9" : "#394c57",
    display: "flex",
    padding: "6px 10px",
    border: "2px solid rgba(238, 238, 238, 0.1)",
  });

  useImperativeHandle(callBackRef, () => ({
    updateValue(ingredients, ingredientGroup) {
      let newVisibleIngredients = ingredients.filter((ingredient) => {
        return ingredient.is_visible;
      });
      const elementsToRemove = visibleIngredients[ingredientGroup]?.filter(
        (element) => {
          return !newVisibleIngredients.includes(element);
        }
      );
      const elementsToAdd = newVisibleIngredients.filter((element) => {
        return !visibleIngredients[ingredientGroup]?.includes(element);
      });
      visibleIngredients[ingredientGroup] = newVisibleIngredients;
      setVisibleIngredients({ ...visibleIngredients });
      let newArray = ingredientList;
      newArray = ingredientList.filter((element) => {
        return !elementsToRemove?.includes(element);
      });
      newArray.push(...elementsToAdd);
      setIngredientList(newArray);

      console.log("newArray at the end of function:");
      console.log(ingredientList);
    },
  }));

  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  }

  function onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    setIngredientList(
      array_move(
        [...ingredientList],
        result.source.index,
        result.destination.index
      )
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided, snapshot) => {
          /*const ingredientList = [];
                Object.values(visibleIngredients).forEach((ingredientGroup) => {
                    ingredientList.push(...ingredientGroup)
                })*/
          let alimentList = [];
          ingredientList.forEach((ingredient) => {
            alimentList.push(
              ...alimentCollection.filter((aliment) => {
                return ingredient._id === aliment._id;
              })
            );
          });
          return (
            <div className={"form-control-wrapper compact"}>
              <label>Nombre</label>
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
                {...provided.droppableProps}
              >
                {ingredientList?.length > 0
                  ? alimentList.map((aliment, index) => {
                      return (
                        <Draggable
                          key={aliment._id}
                          draggableId={aliment._id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              {aliment?.food_name.nameES}
                            </div>
                          )}
                        </Draggable>
                      );
                    })
                  : "Añade ingredientes a la receta para construir el nombre"}

                {provided.placeholder}
              </div>
            </div>
          );
        }}
      </Droppable>
    </DragDropContext>
  );
}
